module.exports = __webpack_public_path__ + "img/37.26d380ae.png";